import type { GesCloudApi, OrganizationListItem } from "@ext/enterprise-cloud/GesCloudApi";
import { createStore } from "zustand";

export interface GesCloudOrganizationStore {
	organizations: OrganizationListItem[];
	isLoading: boolean;
	error: string | null;
	fetchOrganizationsFromApi: (api: GesCloudApi) => Promise<void>;
	setOrganizations: (organizations: OrganizationListItem[]) => void;
	clearAll: () => void;
}

const defaultInitState = {
	organizations: [] as OrganizationListItem[],
	isLoading: false,
	error: null as string | null,
};

const isCurrent = (item: OrganizationListItem) => item.type === "organization" && item.organizationInfo.current;

const compareOrganizations = (a: OrganizationListItem, b: OrganizationListItem) =>
	Number(isCurrent(b)) - Number(isCurrent(a)) ||
	a.organizationInfo.name.localeCompare(b.organizationInfo.name, undefined, { sensitivity: "base" });

export const createGesCloudOrganizationStore = (initState = defaultInitState) => {
	return createStore<GesCloudOrganizationStore>()((set) => ({
		...initState,

		fetchOrganizationsFromApi: async (api: GesCloudApi) => {
			set({ isLoading: true, error: null });

			try {
				const organizations = await api.getUserOrganizations();
				set({ organizations: organizations.sort(compareOrganizations), isLoading: false });
			} catch (error) {
				set({
					error: error instanceof Error ? error.message : "Failed to fetch organizations from API",
					isLoading: false,
				});
			}
		},

		setOrganizations: (organizations: OrganizationListItem[]) => {
			set({ organizations });
		},

		clearAll: () => {
			set({ organizations: [], error: null });
		},
	}));
};
